import { render, staticRenderFns } from "./CriteriaDetailsTemplate.vue?vue&type=template&id=c43de41c"
import script from "./CriteriaDetailsTemplate.vue?vue&type=script&lang=ts"
export * from "./CriteriaDetailsTemplate.vue?vue&type=script&lang=ts"
import style0 from "./CriteriaDetailsTemplate.vue?vue&type=style&index=0&id=c43de41c&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports